(() => {
  'use strict';

  const LABELS = Object.freeze({
    blue: 'Azul',
    azul: 'Azul',
    'light-blue': 'Azul claro',
    'sky-blue': 'Azul claro',
    'baby-blue': 'Azul claro',
    'azul-claro': 'Azul claro',
    'azul-cielo': 'Azul claro',
    navy: 'Azul marino',
    'navy-blue': 'Azul marino',
    'dark-blue': 'Azul marino',
    'azul-marino': 'Azul marino',
    'azul-oscuro': 'Azul marino',
    white: 'Blanco',
    'off-white': 'Blanco',
    blanco: 'Blanco',
    'blanco-hueso': 'Blanco',
    black: 'Negro',
    negro: 'Negro',
    red: 'Rojo',
    rojo: 'Rojo',
    pink: 'Rosado',
    rose: 'Rosado',
    rosa: 'Rosado',
    rosado: 'Rosado',
    beige: 'Beige',
    brown: 'Café',
    coffee: 'Café',
    cafe: 'Café',
    marron: 'Café',
    chocolate: 'Chocolate',
    camel: 'Camel',
    gray: 'Gris',
    grey: 'Gris',
    gris: 'Gris',
    green: 'Verde',
    verde: 'Verde',
    yellow: 'Amarillo',
    amarillo: 'Amarillo',
    orange: 'Naranja',
    naranja: 'Naranja',
    purple: 'Morado',
    violet: 'Morado',
    morado: 'Morado',
    violeta: 'Morado',
    lilac: 'Lila',
    lila: 'Lila',
    burgundy: 'Vinotinto',
    wine: 'Vinotinto',
    vino: 'Vinotinto',
    vinotinto: 'Vinotinto',
    cream: 'Crema',
    crema: 'Crema',
    ivory: 'Marfil',
    marfil: 'Marfil',
    khaki: 'Caqui',
    caqui: 'Caqui',
    coral: 'Coral',
    turquoise: 'Turquesa',
    turquesa: 'Turquesa',
    fuchsia: 'Fucsia',
    fucsia: 'Fucsia',
    gold: 'Dorado',
    dorado: 'Dorado',
    silver: 'Plateado',
    plateado: 'Plateado',
    'black-grey': 'Negro/Gris',
    'black-gray': 'Negro/Gris',
    'black-and-grey': 'Negro/Gris',
    'black-and-gray': 'Negro/Gris',
    'negro-gris': 'Negro/Gris',
    'negro-y-gris': 'Negro/Gris',
    'black-white': 'Negro/Blanco',
    'black-and-white': 'Negro/Blanco',
    'negro-blanco': 'Negro/Blanco',
    'negro-y-blanco': 'Negro/Blanco',
    'blue-white': 'Azul/Blanco',
    'blue-and-white': 'Azul/Blanco',
    'azul-blanco': 'Azul/Blanco',
    'azul-y-blanco': 'Azul/Blanco',
    'red-white': 'Rojo/Blanco',
    'red-and-white': 'Rojo/Blanco',
    'rojo-blanco': 'Rojo/Blanco',
    'rojo-y-blanco': 'Rojo/Blanco',
    'inns-blue': 'INNS azul',
    'inns-black-grey': 'INNS negro/gris',
    'inns-black-gray': 'INNS negro/gris'
  });

  const OPTION_LABELS = Object.freeze({
    color: 'Color',
    colors: 'Color',
    colour: 'Color',
    colours: 'Color',
    couleur: 'Color',
    colores: 'Color',
    tono: 'Color',
    tonos: 'Color',
    size: 'Talla',
    sizes: 'Talla',
    talla: 'Talla',
    tallas: 'Talla',
    tamano: 'Talla',
    tamanos: 'Talla',
    design: 'Diseño',
    designs: 'Diseño',
    print: 'Diseño',
    prints: 'Diseño',
    pattern: 'Diseño',
    patterns: 'Diseño',
    diseno: 'Diseño',
    disenos: 'Diseño',
    estampado: 'Diseño',
    estampados: 'Diseño'
  });

  const handleize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const translateColor = (value) => {
    const clean = String(value || '').trim();
    return LABELS[handleize(clean)] || clean;
  };

  const translateOption = (value) => {
    const clean = String(value || '').trim();
    return OPTION_LABELS[handleize(clean)] || clean;
  };

  const translateVariant = (value) => String(value || '')
    .split('/')
    .map((part) => translateColor(part.trim()))
    .join(' / ');

  const getColorFromClass = (element) => {
    const colorClass = Array.from(element.classList || []).find((name) => name.indexOf('bg_color_') === 0);
    return colorClass ? colorClass.replace('bg_color_', '').replace(/-/g, ' ') : '';
  };

  const accessibleLabel = (label, unavailable) => `Color: ${label}${unavailable ? ', agotado' : ''}`;

  const enhanceProductOptions = (root) => {
    root.querySelectorAll('.is-t4s-style__color [data-swatch-item]').forEach((item) => {
      const raw = item.getAttribute('data-value') || item.getAttribute('title') || item.textContent;
      const label = translateColor(raw);
      const unavailable = item.classList.contains('is--soldout') || item.classList.contains('is--unavailable');

      item.dataset.btSwatch = handleize(raw);
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('title', label);
      item.setAttribute('aria-label', accessibleLabel(label, unavailable));
      item.setAttribute('aria-pressed', item.classList.contains('is--selected') ? 'true' : 'false');
      if (unavailable) item.setAttribute('aria-disabled', 'true');
      if (item.textContent.trim() !== label) item.textContent = label;
    });

    root.querySelectorAll('.is-t4s-style__color[data-swatch-option]').forEach((option) => {
      const selected = option.querySelector('[data-swatch-item].is--selected') || option.querySelector('[data-swatch-item][aria-pressed="true"]');
      const currentNodes = option.querySelectorAll('[data-current-value]');
      const label = selected
        ? translateColor(selected.getAttribute('data-value') || selected.textContent)
        : '';

      option.querySelectorAll('[data-swatch-item]').forEach((item) => {
        item.setAttribute('aria-pressed', item === selected ? 'true' : 'false');
      });

      if (label) {
        currentNodes.forEach((node) => {
          if (node.textContent.trim() !== label) node.textContent = label;
        });
      }
    });
  };

  const updateCardSelection = (box, selected, touched) => {
    if (!selected) return;
    box.querySelectorAll('.t4s-pr-color__item').forEach((item) => {
      const active = item === selected;
      item.classList.toggle('is--selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (touched) box.dataset.btTouched = 'true';
    const nameNode = selected.querySelector('.t4s-pr-color__name');
    const label = translateColor(nameNode ? nameNode.textContent : getColorFromClass(selected.querySelector('.t4s-pr-color__value') || selected));
    const output = box.nextElementSibling && box.nextElementSibling.classList.contains('bt-swatch-selected-name')
      ? box.nextElementSibling
      : null;
    const outputText = `Color: ${label}`;
    if (output && output.textContent.trim() !== outputText) output.textContent = outputText;
  };

  const enhanceProductCards = (root) => {
    root.querySelectorAll('.t4s-product-colors').forEach((box) => {
      const items = Array.from(box.querySelectorAll('.t4s-pr-color__item'));
      if (!items.length || items.some((item) => item.querySelector('.bg_color_ntloading'))) return;

      items.forEach((item) => {
        const nameNode = item.querySelector('.t4s-pr-color__name');
        const valueNode = item.querySelector('.t4s-pr-color__value');
        const raw = nameNode ? nameNode.textContent : getColorFromClass(valueNode || item);
        const label = translateColor(raw);
        const unavailable = item.classList.contains('t4s-pr-color--sold-out') || item.classList.contains('is--soldout');

        item.dataset.btSwatch = handleize(raw);
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('title', label);
        item.setAttribute('aria-label', accessibleLabel(label, unavailable));
        if (unavailable) item.setAttribute('aria-disabled', 'true');
        if (nameNode && nameNode.textContent.trim() !== label) nameNode.textContent = label;
        if (valueNode) valueNode.dataset.btColor = handleize(raw);
      });

      let output = box.nextElementSibling && box.nextElementSibling.classList.contains('bt-swatch-selected-name')
        ? box.nextElementSibling
        : null;
      if (!output) {
        output = document.createElement('span');
        output.className = 'bt-swatch-selected-name';
        output.setAttribute('aria-live', 'polite');
        box.insertAdjacentElement('afterend', output);
      }

      const selected = box.querySelector('.t4s-pr-color__item.is--selected') || items[0];
      updateCardSelection(box, selected, false);
    });
  };

  const enhanceSimpleTranslations = (root) => {
    root.querySelectorAll('[data-bt-color-label]').forEach((node) => {
      const raw = node.getAttribute('data-bt-color-label') || node.textContent;
      const label = translateColor(raw);
      if (node.textContent.trim() !== label) node.textContent = label;
    });

    root.querySelectorAll('[data-bt-variant-title]').forEach((node) => {
      const raw = node.getAttribute('data-bt-variant-title') || node.textContent;
      const label = translateVariant(raw);
      if (node.textContent.trim() !== label) node.textContent = label;
    });

    root.querySelectorAll('[data-bt-option-name]').forEach((node) => {
      const raw = node.getAttribute('data-bt-option-name') || node.textContent;
      const label = translateOption(raw);
      if (node.textContent.trim() !== label) node.textContent = label;
    });
  };

  const enhance = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    enhanceProductOptions(root);
    enhanceProductCards(root);
    enhanceSimpleTranslations(root);
  };

  let scheduled = false;
  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance(document);
    });
  };

  document.addEventListener('click', (event) => {
    const cardItem = event.target.closest('.t4s-product-colors .t4s-pr-color__item');
    if (cardItem && cardItem.getAttribute('aria-disabled') !== 'true') {
      const box = cardItem.closest('.t4s-product-colors');
      window.requestAnimationFrame(() => updateCardSelection(box, cardItem, true));
    }

    if (event.target.closest('.is-t4s-style__color [data-swatch-item]')) scheduleEnhance();
  }, true);

  document.addEventListener('keydown', (event) => {
    const target = event.target.closest('[data-bt-swatch][role="button"]');
    if (!target || target.getAttribute('aria-disabled') === 'true') return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      target.click();
    }
  });

  ['shopify:section:load', 'cart:refresh', 'variant:change', 'product:variant-change'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleEnhance);
  });

  const start = () => {
    enhance(document);
    const observer = new MutationObserver(scheduleEnhance);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.BasictexSwatches = Object.freeze({
    enhance: scheduleEnhance,
    translateColor,
    translateOption,
    translateVariant
  });
})();
